import Component from '../Component';

export default class OverlayComponent extends Component {
    public preventInteraction: boolean = false;
}
